import React from 'react';

const LanguageSwitcher = ({ currentLang, onChange }) => {
  const handleChange = (e) => {
    const selectedLang = e.target.value;

    // Update URL based on selected language
    if (selectedLang === 'en') {
      // English version: root path
      window.history.pushState(null, '', '/');
    } else if (selectedLang === 'hr') {
      // Croatian version: landing page path
      window.history.pushState(null, '', '/p/landing-page-hr');
    }
  };

  const combinedOnChange = (e) => {
    onChange(e.target.value);  // Update parent state
    handleChange(e);           // Update URL
  };

  return (
    <select
      aria-label="Select language"
      value={currentLang}
      onChange={combinedOnChange}
      style={{ height: '100%', maxWidth: '72px' }}
    >
      <option value="en">EN</option>
      <option value="hr">HR</option>
    </select>
  );
};

export default LanguageSwitcher;
